<template>
    <div class="tbmobile-menus">
        <!-- 卡首屏 -->
        <p class="title">卡首屏系列</p>
        <menus-tag-lists :route-type="1" :list="infoData" />
    </div>
</template>

<script>
import { infoData } from '../config'
import MenusTagLists from '../../first_flow/_components/MenusTagLists'

export default {
    components: {
        MenusTagLists
    },
    data() {
        return {
            infoData
        }
    }
}
</script>

<style scoped lang="scss">
.tbmobile-menus {
    p.title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
    }

    .tag-lists {
        padding: 4px 6px;
    }
}

</style>
